exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-travel-select-air-trip-return .select-origin {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.dyna-travel-select-air-trip-return .destination-container {\n  -webkit-box-flex: 1.25;\n      -ms-flex: 1.25;\n          flex: 1.25;\n}\n.dyna-travel-select-air-trip-return .select-depart-date,\n.dyna-travel-select-air-trip-return .select-return-date {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n", ""]);

// exports
